import type { ABTestAssignments } from '../api/ReplicantAPI';
import type { Entry } from '../db/DB';

export function updateABTestAssignments(
    entry: Entry<any>,
    opts: { newAssignments: ABTestAssignments | undefined; isNewUser: boolean },
): void {
    const oldAssignments = entry.metainfo.abTestAssignments ?? {};
    entry.metainfo.abTestAssignments = {};

    // Add assignments to newly activated and keep old assignments to active tests.
    for (const key in opts.newAssignments) {
        const newAssignment = opts.newAssignments[key]!;
        const oldAssignment = oldAssignments[key];

        if (newAssignment.newUsersOnly && !opts.isNewUser && !oldAssignment?.newUsersOnly) {
            continue;
        }

        switch (newAssignment.type) {
            case 'automatic': {
                if (oldAssignment && oldAssignment.type !== 'automatic') {
                    // previous manual assignment takes precedence over new automatic assignment
                    entry.metainfo.abTestAssignments[key] = oldAssignment;
                } else if (newAssignment.isByUserList) {
                    // new automatic assignment by user list takes precedence over old automatic assignment
                    entry.metainfo.abTestAssignments[key] = newAssignment;
                } else {
                    // old automatic assignment takes precedence over new automatic assignment
                    entry.metainfo.abTestAssignments[key] = oldAssignment ?? newAssignment;
                }
                break;
            }
            case 'manual-active':
            case 'manual-inactive': {
                if (oldAssignment?.type === 'automatic') {
                    // the test should manually assigned but hasn't been yet, but the previous test was automatic so use that instead
                    entry.metainfo.abTestAssignments[key] = oldAssignment;
                } else {
                    // ignore: it has been manually set, so it's handled further down
                }
                break;
            }
        }
    }

    for (const key in oldAssignments) {
        if (entry.metainfo.abTestAssignments[key]) {
            continue; // Already handled.
        }

        const oldAssignment = oldAssignments[key]!;
        const newAssignment = opts.newAssignments?.[key];

        if (newAssignment?.type === 'stopped') {
            entry.metainfo.abTestAssignments[key] = oldAssignment;
            continue;
        }

        if (oldAssignment.type === 'automatic') {
            continue;
        }

        // Unassign a test that was rolled back:
        if (newAssignment === undefined) {
            continue;
        }

        // Manually assign a manually assigned test to another bucket:
        entry.metainfo.abTestAssignments[key] = { ...oldAssignment, type: 'manual-inactive' };
    }
}
